import React, { useEffect, useState } from "react";
import FormModals from "./FormModals";
import { useTranslation } from "../../../context/TranslationContext";

const FormBtn = ({ disabled, handleSubmit, onModalClose }) => {
  const { getOfferSendBtn } = useTranslation();
  const [show, setShow] = useState(false);
  return (
    <>
      <button
        className=" py-3 md:py-[18px] md:px-[52px] text-white px-7 bg-brand-color-primary disabled:opacity-75 disabled:cursor-not-allowed"
        onClick={() => {
          handleSubmit(setShow);
        }}
        disabled={!disabled}
      >
        {getOfferSendBtn}
      </button>
      {<FormModals onModalClose={onModalClose} show={show} setShow={setShow} />}
    </>
  );
};

export default FormBtn;
